import { Rocket, Trophy, Info } from "lucide-react";

type View = "game" | "highscores" | "about";

type NavbarProps = {
  view?: View;
  setView: (view: View) => void;
};

const links: { id: View; label: string; icon: JSX.Element }[] = [
  { id: "game", label: "Gra", icon: <Rocket size={16} /> },
  { id: "highscores", label: "Najlepsze wyniki", icon: <Trophy size={16} /> },
  { id: "about", label: "O grze", icon: <Info size={16} /> },
];

export function Navbar({ view = "game", setView }: NavbarProps) {
  const go = (v: View) => setView(v);
  return (
    <nav className="navbar">
      <span
        className="navbar-title"
        onClick={() => go("game")}
        role="button"
        tabIndex={0}
      >
        🚀 Spacesheep
      </span>
      <div className="navbar-links">
        {links.map((l) => (
          <span
            key={l.id}
            className={"navbar-link" + (view === l.id ? " active" : "")}
            onClick={() => go(l.id)}
            role="button"
            tabIndex={0}
          >
            {l.icon}
            {l.label}
          </span>
        ))}
      </div>
    </nav>
  );
}
